import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	type: '',
	message: '',
	messageTime: ''
};

export const notificationsSlice = createSlice({
	name: 'notifications',
	initialState,
	reducers: {
		successMessage: (state, action) => {
			state.message = action.payload;
			state.messageTime = new Date();
			state.type = 'success';
		},
		failureMessage: (state, action) => {
			state.message = action.payload;
			state.messageTime = new Date();
			state.type = 'failure';
		},
		clearMessage: (state) => {
			state.message = '';
			state.messageTime = '';
			state.type = '';
		}
	}
});

export const { successMessage, failureMessage, clearMessage } =
	notificationsSlice.actions;

export default notificationsSlice.reducer;
